import { jsx as o, jsxs as n } from "react/jsx-runtime";
import { useState as l } from "react";
import { Popover as s, Transition as m } from "@headlessui/react";
import { Cookies as p } from "../../constants/cookies.js";
import { usePageRoute as u } from "../../hooks/use-page-route.js";
import { useTranslate as d } from "../../hooks/use-translate.js";
import { makeClassesByStyles as y } from "../../utils/classes.js";
import { setCookie as f } from "../../utils/cookies.js";
import { GradientBorderWrapper as k } from "../gradient-border-wrapper/gradient-border-wrapper.js";
import { Button as h } from "../shared/components/button/button.js";
import { Link as b } from "../shared/components/link/link.js";
import v from "../../assets/5074ec9a.cookie-policy-consent.module.css";
const e = y(v), F = () => {
  const t = d(), [r, i] = l(!0), a = u("cookies-policy") ?? "", c = () => {
    f(p.IsCookiePolicyAccepted, "true", 30), i(!1);
  };
  return r ? /* @__PURE__ */ o(s, { className: e("InfoPopover"), "data-testid": "cookies-popover", children: r && /* @__PURE__ */ o(
    m,
    {
      appear: !0,
      show: r,
      enter: "transition-transform duration-300",
      enterFrom: " translate-y-full opacity-0",
      enterTo: " translate-y-0 opacity-100",
      leave: "transition-transform duration-300",
      leaveFrom: "translate-y-full opacity-100",
      leaveTo: "translate-y-0 opacity-0",
      children: /* @__PURE__ */ o(k, { color: "quaternary", borderRadius: "rounded-sm", children: /* @__PURE__ */ n(s.Panel, { static: !0, className: e("panel"), children: [
        /* @__PURE__ */ o("p", { className: e("content"), children: t("cookie-policy-consent.copy") }),
        /* @__PURE__ */ n("div", { className: e("buttons-container"), children: [
          /* @__PURE__ */ o(
            b,
            {
              className: e("button"),
              styledAs: "button",
              color: "secondary",
              href: a,
              size: "full",
              text: t("cookie-policy-consent.button.read-more"),
              withGradientBorder: !0
            }
          ),
          /* @__PURE__ */ o(
            h,
            {
              className: e("button"),
              size: "md",
              text: t("cookie-policy-consent.button.accept"),
              color: "primary",
              handleClick: c
            }
          )
        ] })
      ] }) })
    }
  ) }) : null;
};
export {
  F as CookiePolicyConsent
};
